"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiEmailInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usePrevious_1 = require("../../hooks/usePrevious");
const email_1 = require("../Form/validations/email");
const required_1 = require("../Form/validations/required");
const EmailPill_1 = require("./EmailPill");
const lib_1 = require("../../lib");
const MultiEmailInput = ({ onChange, autoFocus, className }) => {
    const [state, setState] = (0, react_1.useState)({
        inputValue: '',
        focussed: false,
        valid: true,
        empty: false,
        emails: [],
        editingEmailIndex: null
    });
    const prevState = (0, usePrevious_1.usePrevious)(state);
    (0, react_1.useEffect)(() => {
        if (state.valid !== prevState.valid || state.emails !== prevState.emails) {
            onChange(state.emails, state.valid);
        }
    }, [state, prevState]);
    const isValid = (0, react_1.useCallback)((emails) => !!emails.filter(e => (0, email_1.email)(e)).length, []);
    const isValidInput = (0, react_1.useCallback)((inputValue) => !(0, email_1.email)(inputValue), []);
    const isEmptyInput = (0, react_1.useCallback)((inputValue) => !!(0, required_1.required)(inputValue), []);
    const isEmpty = (0, react_1.useCallback)((emails) => !emails.length, []);
    const handleAddEmail = (0, react_1.useCallback)((inputValue) => {
        setState((prev) => {
            const emails = [...prev.emails, inputValue];
            const state = Object.assign(Object.assign({}, prev), { emails, inputValue: '', valid: !isValid(emails) });
            return state;
        });
    }, [setState, onChange, isValid]);
    const handleRemoveEmail = (0, react_1.useCallback)((index) => {
        setState((prev) => {
            const { emails, editingEmailIndex } = prev;
            return Object.assign(Object.assign({}, prev), { emails: emails.filter((email, idx) => idx !== index), valid: !isValid(emails), empty: isEmpty(emails), editing: index === editingEmailIndex ? null : editingEmailIndex });
        });
    }, [setState, isEmpty, isValid]);
    const handleEditEmail = (0, react_1.useCallback)((index, text) => {
        setState((prev) => {
            const { emails } = prev;
            return Object.assign(Object.assign({}, prev), { emails: emails.map((email, idx) => (index === idx ? text : email)) });
        });
    }, [setState]);
    const handlePillChange = (0, react_1.useCallback)((index) => (e) => {
        const input = e.target.value;
        handleEditEmail(index, input);
    }, [handleEditEmail]);
    const handleSelectPill = (0, react_1.useCallback)((index) => () => {
        const { editingEmailIndex } = state;
        if (index === null &&
            editingEmailIndex !== null &&
            state.emails[editingEmailIndex].length === 0)
            handleRemoveEmail(editingEmailIndex);
        setState((prev) => (Object.assign(Object.assign({}, prev), { editingEmailIndex: index, valid: index === null ? !isValid(emails) : prev.valid })));
    }, [state, setState, handleRemoveEmail, isValid]);
    const handleChange = (0, react_1.useCallback)((e) => {
        const inputValue = e.target.value;
        setState((prev) => (Object.assign(Object.assign({}, prev), { inputValue, empty: false })));
    }, [setState]);
    const handleFocus = (0, react_1.useCallback)((e) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { focus: true, empty: false })));
    }, [setState]);
    const handleBlur = (0, react_1.useCallback)((e) => {
        if (!isEmptyInput(state.inputValue))
            handleAddEmail(state.inputValue);
        setState((prev) => (Object.assign(Object.assign({}, prev), { focus: false, empty: isEmpty(prev.emails) })));
    }, [setState, state.inputValue, isEmptyInput, handleAddEmail, isEmpty]);
    const handleKeyPress = (0, react_1.useCallback)((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            if (!isEmptyInput(state.inputValue))
                handleAddEmail(state.inputValue);
            else
                setState((prev) => (Object.assign({}, prev)));
        }
    }, [setState, isEmptyInput, handleAddEmail, state.inputValue]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        if (!isEmpty(state.emails) &&
            isEmptyInput(state.inputValue) &&
            e.key === 'Backspace')
            handleRemoveEmail(state.emails.length - 1);
    }, [isEmpty, isEmptyInput, handleRemoveEmail, state.emails, state.inputValue]);
    const { emails, inputValue, focussed, valid, empty, editingEmailIndex } = state;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)('multi-email-input', className) }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)('multi-email-input__wrapper', focussed && valid ? '--active' : null, !valid || empty ? '--error' : null) }, { children: [emails.map((text, idx) => ((0, jsx_runtime_1.jsx)(EmailPill_1.EmailPill, { text: text, selected: idx === editingEmailIndex, error: !!(0, email_1.email)(text), remove: () => handleRemoveEmail(idx), onBlur: handleSelectPill(null), onClick: handleSelectPill(idx), onChange: handlePillChange(idx) }, idx))), (0, jsx_runtime_1.jsx)("input", { autoFocus: autoFocus, className: "multi-email-input__input", type: "email", placeholder: emails.length ? '' : 'Add recipients', value: inputValue, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onKeyPress: handleKeyPress, onKeyDown: handleKeyDown }, void 0)] }), void 0), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "multi-email-input__errors" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "multi-email-input__error --error" }, { children: !valid ? 'Please ensure emails are valid.' : null }), void 0), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)('multi-email-input__error', empty ? '--error' : null) }, { children: "Required" }), void 0)] }), void 0)] }), void 0));
};
exports.MultiEmailInput = MultiEmailInput;
//# sourceMappingURL=MultiEmailInput.js.map